import React from "react";
import Section from "../components/shared/Section";
import image1 from "../images/gallery/1.jpg";

export default function About() {
  return (
    <Section id="about">
      <div className="grid lg:grid-cols-2 gap-16 items-center text-center sm:text-left">
        {/* Text Content */}
        <div>
          <h2 className="text-3xl sm:text-4xl font-semibold text-white ">
            Our{" "}
            <span className="text-yellow-700 drop-shadow-[0_1px_8px_rgba(255,200,0,0.15)] ">
              Purpose
            </span>
          </h2>

          <p className="mt-6 text-neutral-300 leading-relaxed">
            {/* Welcome to{" "} */}
            <span className="font-semibold text-yellow-300">Beyond Box{" "}</span>
             provides premium building materials, with a strong foothold in the B2B and projects segment in
            Karnataka aiming at South-India Market. Building the Brand that adds
            and enhances value to Channel Partners & Spaces.
          </p>

          <p className="mt-4 text-neutral-300 leading-relaxed">
            Our commitment to precision and craftsmanship ensures top-quality
            products that meet industry standards for a seamless finish and
            lasting performance.Our understanding of the B2B ecosystem and
            project-driven market gives us a clear edge in driving brand
            presence and sustainable growth for our partners.
          </p>
        </div>

        {/* Image Content */}
        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-xl group">
          <img
            src={image1}
            alt="Factory and profiles"
            className="h-80 w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/30" />
        </div>
      </div>
    </Section>
  );
}
